import React, { PureComponent } from 'react';
import Select from 'react-select';
import { toast } from 'react-toastify';

import LoadingCenter from '../../../Components/LoadingCenter';
import BackButtonRouter from '../../../Components/BackButtonRouter';
import InputRow from '../../../Components/InputRow';
import TextArea from '../../../Components/TextArea';
import DeleteButton from '../../../Components/DeleteButton';

import APIGet from '../../../API/APIGet';
import APIPost from '../../../API/APIPost';
import APIPut from '../../../API/APIPut';
import APIDelete from '../../../API/APIDelete';
import APIHelper from '../../../Helper/APIHelper';
import AuthHelper from '../../../Helper/AuthHelper';

import STAFF_ROLE from '../../../StaticData/StaffRole';

import AppConfig from '../../../AppConfig';

export default class StaffDetail extends PureComponent {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: true,
			role: STAFF_ROLE[0],
			name: '',
			email: '',
			nickname: '',
			telephone: '',
		};
	}

	async componentDidMount() {
		if (AuthHelper.hasRight('Staff', 'Reporter', 'Finance', 'Admin')) {
			let initUpdate = true;
			if (this.isUpdate()) {
				initUpdate = await this.initUpdate();
			}

			if (initUpdate) {
				this.setState({
					isLoading: false,
				});
			}
		} else {
			toast.warn('คุณไม่มีสิทธิ์ใช้งานในหน้านี้');
		}
	}

	initUpdate = async () => {
		const { staffId } = this.props.match.params;
		let requestStaff = APIGet('staffs/' + staffId);
		requestStaff = await requestStaff;
		if (APIHelper.handleAPIResponse(this, requestStaff)) {
			const staff = requestStaff.data;
			console.log('staff: ', staff);
			this.setState({
				name: staff.name,
				role: STAFF_ROLE.filter(ct => ct.value === staff.role)[0],
				email: staff.email,
				telephone: staff.telephone,
				nickname: staff.nickname,
			});

			return true;
		} else if (requestStaff.status === 404) {
			toast.warning('ไม่พบข้อมูลดังกล่าว');
			return false;
		} else {
			toast.error('ไม่สามารถดึงข้อมูลได้ กรุณาลองใหม่อีกครั้ง');
			return false;
		}
	};

	isUpdate = () => {
		const { staffId } = this.props.match.params;
		if (staffId) {
			return true;
		} else {
			return false;
		}
	};

	save = async () => {
		const { staffId } = this.props.match.params;
		if (this.validateSaveState()) {
			this.setState({
				isLoading: true,
			});

			let data = {
				name: this.state.name,
				role: this.state.role.value,
				email: this.state.email,
				telephone: this.state.telephone,
				nickname: this.state.nickname,
			};

			let request = null;
			if (this.isUpdate()) {
				request = await APIPut('staffs/' + staffId, data);
			} else {
				request = await APIPost('staffs', data);
			}

			if (APIHelper.handleAPIResponse(this, request)) {
				toast.success(this.isUpdate() ? 'แก้ไขเรียบร้อยแล้ว' : 'เพิ่มเรียบร้อยแล้ว');
				const result = request.data;
			} else {
				toast.error('เกิดปัญหาในการเพิ่ม Staff');
			}

			this.setState({
				isLoading: false,
			});
		}
	};

	validateSaveState = () => {
		const role = this.state.role && this.state.role.value;
		if (!role) {
			toast.warn('กรุณาระบุ Role');
		}

		const name = this.state.name.trim() !== '';
		if (!name) {
			toast.warn('กรุณาระบุชื่อ');
		}

		const telephone = this.state.telephone.trim() !== '';
		if (!telephone) {
			toast.warn('กรุณาระบุเบอร์โทรศัพท์');
		}

		const email = this.state.email.trim() !== '';
		if (!email) {
			toast.warn('กรุณาระบุ email');
		}

		return role && name && telephone && email;
	};

	resetPassword = async () => {
		const { staffId } = this.props.match.params;
		this.setState({
			isLoading: true,
		});

		let requestReset = APIPut('staffs/' + staffId + '/resetPassword');
		requestReset = await requestReset;
		if (APIHelper.handleAPIResponse(this, requestReset)) {
			toast.success('แก้ Password เรียบร้อยแล้ว');
			this.props.history.replace(AppConfig.appPath + '/data/staffs');
		} else {
			toast.error('ไม่สามารถแก้ได้ กรุณาลองใหม่อีกครั้ง');
			this.setState({
				isLoading: false,
			});
		}
	};

	delete = async () => {
		const { staffId } = this.props.match.params;
		this.setState({
			isLoading: true,
		});

		let requestDelete = APIDelete('staffs/' + staffId);
		requestDelete = await requestDelete;
		if (APIHelper.handleAPIResponse(this, requestDelete)) {
			toast.success('ลบเรียบร้อยแล้ว');
			this.props.history.replace(AppConfig.appPath + '/data/staffs');
		} else {
			toast.error('ไม่สามารถลบได้ กรุณาลองใหม่อีกครั้ง');
			this.setState({
				isLoading: false,
			});
		}
	};

	onTextChange = (type, value) => {
		this.setState({
			[type]: value,
		});
	};

	handleSelectChange = (type, value) => {
		this.setState({
			[type]: value,
		});
	};

	render() {
		if (this.state.isLoading) {
			return <LoadingCenter />;
		}

		return (
			<div className="container">
				<BackButtonRouter />
				<div className="section">
					<div className="columns">
						<div className="column is-6">
							<h3 className="title is-3">{this.isUpdate() ? 'แก้ไข Staff' : 'เพิ่ม Staff'}</h3>
						</div>
					</div>
					<div className="columns">
						<div className="column is-4">
							<InputRow
								title="email"
								labelSize="s"
								placeholder="email"
								keyProps="email"
								onInputChange={this.onTextChange}
								value={this.state.email}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="ชื่อ"
								labelSize="s"
								placeholder="ชื่อ"
								keyProps="name"
								onInputChange={this.onTextChange}
								value={this.state.name}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="ชื่อเล่น"
								labelSize="s"
								placeholder="ชื่อเล่น"
								keyProps="nickname"
								onInputChange={this.onTextChange}
								value={this.state.nickname}
								disabled={false}
								isMandatory={false}
							/>
						</div>
					</div>
					<div className="columns row">
						<div className="column is-4">
							<label className="label">role</label>
							<Select
								name="type"
								value={this.state.role}
								clearable={false}
								onChange={value => this.handleSelectChange('role', value)}
								options={STAFF_ROLE}
							/>
						</div>
						<div className="column is-4">
							<InputRow
								title="telephone"
								labelSize="s"
								placeholder="telephone"
								keyProps="telephone"
								onInputChange={this.onTextChange}
								value={this.state.telephone}
								disabled={false}
								isMandatory={false}
							/>
						</div>
						<div className="column is-4" style={{ paddingTop: 45 }}>
							<button className="button is-warning" onClick={this.resetPassword}>
								Reset Password (ให้เป็น 123456)
							</button>
						</div>
					</div>
					<div className="columns row">
						<div className="column is-6">
							{this.isUpdate() && this.state.role && this.state.role.value !== 'Admin' ? (
								<DeleteButton label="ลบ" warningMessage="ยืนยันการลบ" onClick={this.delete} />
							) : null}
						</div>
						<div className="column is-6" style={{ textAlign: 'right', marginTop: 20 }}>
							<button className="button is-success" onClick={this.save}>
								บันทึก
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
